import React, { FC, memo } from 'react'
import { GridLayout, BigTeaserHeadlineFont } from '@sport1/news-styleguide'
import CardHeader from '../../../Shared/CardHeader'

type Props = {
    title: string
    imageUrl: string
    text: string
}

const EmptyPollFragment: FC<Props> = ({ title, imageUrl, text }) => {
    return (
        <>
            <CardHeader text={title} imageUrl={imageUrl} />
            <GridLayout
                columnType="100"
                firstColumn={<BigTeaserHeadlineFont>{text}</BigTeaserHeadlineFont>}
                spaceY="small"
            />
        </>
    )
}

export default memo(EmptyPollFragment)
